module.exports = __webpack_public_path__ + "img/GeekRatingVsOwnsCluster.7bf26d10.png";